module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"optimizer":"Optimizer","manualConfig":"Manual config","menuEditor":"Menu editor","reporting":"Reporting","masters":"Master data"},"es":{"optimizer":"Optimizador","manualConfig":"Configuración manual","menuEditor":"Editor de menú","reporting":"Informes","masters":"Gestión de maestros"}}')
  delete Component.options._Ctor
}
